import React, { useRef } from 'react';

interface MessageAttachmentPickerProps {
  fileName: string | null;
  disabled?: boolean;
  error?: string | null;
  onFile: (file: File) => void;
  onClear: () => void;
}

const MessageAttachmentPicker: React.FC<MessageAttachmentPickerProps> = ({
  fileName,
  disabled = false,
  error = null,
  onFile,
  onClear,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="min-w-0">
      <div className="flex min-w-0 items-center gap-2">
        <button
          type="button"
          aria-label="Add attachment"
          disabled={disabled}
          onClick={() => inputRef.current?.click()}
          className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full text-white hover:bg-white/10 disabled:cursor-not-allowed disabled:opacity-40"
        >
          <svg
            className="h-4 w-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            aria-hidden
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21.44 11.05l-8.49 8.49a5.5 5.5 0 01-7.78-7.78l8.49-8.49a3.5 3.5 0 014.95 4.95l-8.49 8.49a1.5 1.5 0 01-2.12-2.12l7.78-7.78"
            />
          </svg>
        </button>
        {fileName ? (
          <span className="flex min-w-0 items-center gap-1 text-xs text-white">
            <span className="truncate">{fileName}</span>
            <button
              type="button"
              aria-label="Remove attachment"
              disabled={disabled}
              onClick={onClear}
              className="flex-shrink-0 text-gray-400 hover:text-white disabled:opacity-40"
            >
              ×
            </button>
          </span>
        ) : null}
        <input
          ref={inputRef}
          type="file"
          accept="image/jpeg,image/png,image/webp,image/gif,application/pdf"
          className="hidden"
          onChange={event => {
            const file = event.target.files?.[0];
            event.target.value = '';
            if (file) onFile(file);
          }}
        />
      </div>
      {error ? <p className="mt-1 text-xs text-red-400">{error}</p> : null}
    </div>
  );
};

export default MessageAttachmentPicker;
